import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import logoServicosDigitaisWhite from '@ibk/shared-assets/icons/logo-servicosdigitais-white.svg';
import logoServicosDigitais from '@ibk/shared-assets/icons/logo-servicosdigitais.svg';
import logoTr from '@ibk/shared-assets/icons/logo-tr.svg';
export const Logo = ({ type = 'servicosdigitais', alt = 'Logo', ...props }) => {
    const src = type === 'tr' ? logoTr : type === 'servicosdigitais-white' ? logoServicosDigitaisWhite : logoServicosDigitais;
    return _jsx("img", { src: src, alt: alt, ...props });
};
